/**
 * Contract Dashboard Reducers
 */
import {
  GET_PENDING_CONTRACT,
  CONTRACT_PENDING_ACTION,
  GET_ENDING_CONTRACT,
  GET_CANCEL_CONTRACT,
  GET_ACCEPT_CONTRACT,
  GET_NEW_CONTRACT,
  GET_STUDENT_PROGRAM_INCLUSION,
  GET_STUDENT_PROGRAM,
  GET_MONTH_CONTRACT,
  GET_CONTRACT_INSTALLMENT,
  UPDATE_INSTALLMENT_STATUS,
  SEND_EMAIL_CONTRACT_NOTIFICATION,
} from 'Actions/types';

const INIT_STATE = {
  contractpendinglist: [],
  contractendinglist: [],
  contractcancellist: [],
  contractacceptlist: [],
  contractprogramlist: [],
  newcontractlist:[],
  monthcontractlist:[],
  contractinstallmentlist:[],
  loading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CONTRACT_PENDING_ACTION:
      return { ...state, loading: true };

    case GET_PENDING_CONTRACT:
      return { ...state, loading: false, contractpendinglist: action.payload };

    case GET_ENDING_CONTRACT:
      return { ...state, loading: false, contractendinglist: action.payload };

    case GET_CANCEL_CONTRACT:
      return { ...state, loading: false, contractcancellist: action.payload };

    case GET_ACCEPT_CONTRACT:
      return { ...state, loading: false, contractacceptlist: action.payload };

    case GET_NEW_CONTRACT:
      return { ...state, loading: false, newcontractlist: action.payload };

    case GET_STUDENT_PROGRAM_INCLUSION:
      return { ...state, loading: false, contractprogramlist: action.payload };

    case GET_STUDENT_PROGRAM:
      return { ...state, loading: false, contractagreementlist: action.payload };

    case GET_MONTH_CONTRACT:
      return { ...state, loading: false, monthcontractlist: action.payload };

    case GET_CONTRACT_INSTALLMENT:
      return { ...state, loading: false, contractinstallmentlist: action.payload };

    case UPDATE_INSTALLMENT_STATUS:
      return { ...state, loading: false };

    case SEND_EMAIL_CONTRACT_NOTIFICATION:
      return { ...state, loading: false };

    default:
      return { ...state };
  }
};

